import { render, staticRenderFns } from "./NoteDetails.vue?vue&type=template&id=46ee2588&scoped=true"
import script from "./NoteDetails.vue?vue&type=script&lang=js"
export * from "./NoteDetails.vue?vue&type=script&lang=js"
import style0 from "./NoteDetails.vue?vue&type=style&index=0&id=46ee2588&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46ee2588",
  null
  
)

export default component.exports